import script from "./Board.vue?vue&type=script&setup=true&lang=js"
export * from "./Board.vue?vue&type=script&setup=true&lang=js"

import "./Board.vue?vue&type=style&index=0&id=080aa7ae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-080aa7ae"]])

export default __exports__